<template>
    <div class="pagination">
        <nav class="mr-3" v-if="total > 1 || current > 1">
            <ul class="pagination-nav">
                <li v-if="total > 1" @click="clickPrevious()">
                    <span
                        class="pagination-link is-prev"
                        :class="{ 'is-disabled': current === 1 }"
                    >
                        <a-icon icon="Left" />
                        <span class="ml-1 d-none d-sm-inline">Poprzednie</span>
                    </span>
                </li>
                <li v-if="total > 3 && current >= 3">
                    <a class="pagination-link" @click="clickPaginate(1)">
                        <span>1</span>
                    </a>
                </li>
                <li v-if="total > 4 && current >= 4">
                    <a class="pagination-link cursor-default">
                        <span>...</span>
                    </a>
                </li>
                <li v-if="total > 2 && current === total">
                    <a
                        class="pagination-link"
                        @click="clickPaginate(current - 2)"
                    >
                        <span>{{ current - 2 }}</span>
                    </a>
                </li>
                <li v-if="current > 1">
                    <a
                        class="pagination-link"
                        @click="clickPaginate(current - 1)"
                    >
                        <span>{{ current - 1 }}</span>
                    </a>
                </li>
                <li v-if="total > 1">
                    <a class="pagination-link is-active">
                        <span>{{ current }}</span>
                    </a>
                </li>
                <li v-if="total > 1 && current !== total">
                    <a
                        class="pagination-link"
                        @click="clickPaginate(current + 1)"
                    >
                        <span>{{ current + 1 }}</span>
                    </a>
                </li>
                <li v-if="total > 2 && current === 1">
                    <a
                        class="pagination-link"
                        @click="clickPaginate(current + 2)"
                    >
                        <span>{{ current + 2 }}</span>
                    </a>
                </li>
                <li v-if="total > 4 && current < total - 2">
                    <a class="pagination-link cursor-default">
                        <span>...</span>
                    </a>
                </li>
                <li v-if="total > 3 && current < total - 1">
                    <a class="pagination-link" @click="clickPaginate(total)">
                        <span>{{ total }}</span>
                    </a>
                </li>
                <li v-if="total > 1" @click="clickNext()">
                    <a
                        class="pagination-link is-next"
                        :class="{ 'is-disabled': current === total }"
                    >
                        <span class="mr-1 d-none d-sm-inline">Następne</span>
                        <a-icon icon="Right" />
                    </a>
                </li>
            </ul>
        </nav>
        <slot />
    </div>
</template>

<script>
export default {
    name: 'ThePagination',
    data() {
        return {
            elements: []
        }
    },
    props: {
        current: {
            type: Number,
            required: true
        },
        total: {
            type: Number,
            required: true
        },
        perPage: {
            type: Number,
            required: true
        },
        onChange: {
            type: Function
        }
    },
    methods: {
        clickPrevious() {
            if (this.current > 1) {
                window.scrollTo(0, 0)
                this.onChange(this.current - 1)
            }
        },
        clickNext() {
            if (this.total > 1 && this.current < this.total) {
                window.scrollTo(0, 0)
                this.onChange(this.current + 1)
            }
        },
        clickPaginate(args) {
            window.scrollTo(0, 0)
            this.onChange(args)
        }
    }
}
</script>
